import PropTypes from 'prop-types';

import styles from 'styles/components/checkout/caap/errorList.scss';

const ErrorList = ({ errorList, errorHeading }, { testId }) => {
  if (!errorList || !errorList.length) {
    return null;
  }

  const content = makeErrorList({ errorHeading, errorList, testId });
  return (
    <div className={styles.errorContainer} data-test-id={testId('errorContainer')}>
      { content }
    </div>
  );
};

const makeErrorList = ({ errorHeading, errorList, testId }) => (
  <div>
    {
      errorHeading
        ? <h2 className={styles.errorHeading}>{errorHeading}</h2>
        : null
    }
    {
      errorList.map((error, index) => <p key={index} data-test-id={testId('errorListItem')}> {error} </p>)
    }
  </div>
);

ErrorList.contextTypes = {
  testId: PropTypes.func
};

export default ErrorList;
